import { FieldPath } from "react-hook-form";
type SearchLabelsType = {
    [key in FieldPath<SearchFormInputs>]: string;
};

export const SearchLabels: Partial<SearchLabelsType> = {
    focus: "Your ideal holidays are?",
    month: "When do you want to go?",
    continent: "Where do you want to go?",
    suitability: "Who are you travelling with?",
    distance: "Travelling for activities",
    "weather.tmin": "Night temperature",
    "weather.tmax": "Day temperature",
    "weather.sst": "Sea temperature",
    "weather.wet": "Wet days",
    "weather.rhm": "Humidity",
    "weather.ws": "Wind speed",
    "weather.sunhrs": "Sunshine hours",
    "weather.dayhrs": "Daylight hours",
    "weather.rainseason": "Avoiding rain season",
    "prices.pricesOverall": "Overall prices",
    "prices.accomodation": "Accomodation prices",
    "prices.mealRestaurant": "Meal prices at restaurant",
    "prices.beer": "Beer prices",
    "prices.coffee": "Coffee prices",
    "prices.mealShop": "Meal prices at shop",
    "prices.entranceFees": "Entrance fees",
    "prices.flightTickets": "Flight tickets",
    "prices.flightOrigin": "Flight origin",
    "nature.mountainHiking": "Mountain hiking",
    "nature.easyNatureHiking": "Hiking",
    "nature.rockClimbing": "Rock climbing",
    "nature.roadCycling": "Road cycling",
    "nature.mountainBiking": "Mountain biking",
    "nature.alpineSkiing": "Alpine skiing",
    "nature.nordicSkiing": "Nordic skiing",
    "nature.rafting": "Rafting",
    "nature.canyoning": "Canyoning",
    "nature.jungleTrekking": "Jungle trekking",
    "nature.volcanoTrekking": "Volcano trekking",
    "nature.polarLights": "Polar lights",
    "nature.dolphinsAndWhales": "Dolphins and whales",
    "nature.animalsWatching": "Animals watching",
    "nature.safari": "Safari",
    "nature.waterfalls": "Waterfalls",
    "nature.peaksSummits": "Peaks and summits",
    "nature.nationalPark": "National park",
    "nature.hotSprings": "Hot springs",
    "beachSports.scubaDiving": "Scuba diving",
    "beachSports.snorkelling": "Snorkelling",
    "beachSports.surfing": "Surfing",
    "beachSports.windsurfing": "Windsurfing",
    "beachSports.kitesurfing": "Kitesurfing",
    "beachSports.paddleboarding": "Paddleboarding",
    "beachSports.sailing": "Sailing",
    "beachSports.fishing": "Fishing",
    "city.scenicDowntown": "Scenic downtown",
    "city.sacralBuildings": "Sacral buildings",
    "city.shoppingPossibilities": "Shopping possibilities",
    "city.modernArchitecture": "Modern architecture",
    "city.picturesqueStreets": "Picturesque streets",
    "city.panoramicVistas": "Panoramic vistas",
    "city.cityPanoramicViewpoints": "City panoramic viewpoints",
    "city.castlesMansions": "Castles and mansions",
    "city.historicalArchitecture": "Historical architecture",
    "city.themeParks": "Theme parks",
    "scenes.yoga": "Yoga",
    "scenes.traditionalDancesAndArts": "Traditional dances and arts",
    "scenes.streetFood": "Street food",
    "scenes.fineDining": "Fine dining",
    "scenes.electronicDanceMusic": "Electronic dance music",
    "scenes.digitalNomads": "Digital nomads",
    "scenes.latinoDance": "Latino dance",
    "beach.sand": "Sand",
    "beach.pebble": "Pebble",
    "beach.rocky": "Rocky",
    "beach.tropical": "Tropical",
    "beach.secluded": "Secluded",
    "beach.picturesque": "Picturesque",
    "beach.turquise": "Turquoise",
    "beach.palms": "Palms",
    "beach.mountainViews": "Mountain views",
    "beach.kiosks": "Kiosks",
    "beach.sunbeds": "Sunbeds",
    "beach.accessible": "Accessible",
    "landscapes.mountains": "Mountains",
    "landscapes.hills": "Hills",
    "landscapes.volcano": "Volcano",
    "landscapes.desert": "Desert",
    "landscapes.forests": "Forests",
    "landscapes.untypicalLandscape": "Untypical landscape",
    "landscapes.lake": "Lake",
    "landscapes.wildRiver": "Wild river",
    "landscapes.tropicalForest": "Tropical forest",
    "other.season": "Season",
    "other.englishKnowledge": "English knowledge",
    "other.vaccinationRequirements": "Vaccination requirements",
    "other.citySize": "City size",
    "other.airportDistance": "Airport distance",
    "other.island": "Island",
    "other.boat": "Boat",
    "other.visa": "Visa",
    "other.visaOrigin": "Visa origin"
};

export const SearchLabelsForChips: Partial<SearchLabelsType> = {
    focus: "Ideal holidays",
    month: "Period",
    continent: "Destination",
    suitability: "Travelling with",
    distance: "Short activities distances",
    "weather.rainseason": "Avoid rain season",
    "beach.sand": "Sand beach",
    "beach.pebble": "Pebble beach",
    "beach.rocky": "Rocky beach",
    "beach.tropical": "Tropical beach",
    "beach.secluded": "Secluded beach",
    "beach.picturesque": "Picturesque beach",
    "beach.turquise": "Turquoise beach",
    "beach.palms": "Beach with palms",
    "beach.mountainViews": "Beach with mountain views",
    "beach.kiosks": "Beach with kiosks",
    "beach.sunbeds": "Beach with sunbeds",
    "beach.accessible": "Accessible beach",
    "other.season": "Season",
    "other.englishKnowledge": "High level of English",
    "other.vaccinationRequirements": "Low vaccination requirements",
    "other.citySize": "City size",
    "other.airportDistance": "Short airport distance",
    "other.island": "Island",
    "other.boat": "Avoid boat",
    "other.visa": "Low visa requirements"
};
